export default __webpack_public_path__ + "b7e0eb3fca7c143b211e2458100c70c9.png";